import axios from "axios";
import { get, some } from "lodash";

// state
const state = {
  allHistory: [],
  singleOrder: {},
  isFetchingOrderDetails: false,
  unavailableListOfItems: [],
  pastPurchases: {
    productItems: [],
    totalCount: 0,
  },
};

const actions = {
  GET_PAST_PURCHASES({ COMMIT }, params) {
    var vm = this;
    vm.commit("errors/CLEAR_ERRORS");

    axios
      .all([
        axios.get("/commerce-api/v1/orderHistory/frequentlyPurchased", {
          params: params,
        }),
      ])
      .then(
        axios.spread((response) => {
          vm.commit("orderHistory/SET_PAST_PURCHASES", response.data);
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit("errors/PUSH_ERROR", {
            message: error.response.data.title,
            code: error.response.status,
          });
        } else if (error.request) {
          vm.commit("errors/PUSH_ERROR", {
            message: "Couldn't contact the website",
          });
          console.log(error.request);
        } else {
          console.log("Error", error.message);
          vm.commit("errors/PUSH_ERROR", { message: error.message });
        }
        console.log(error.config);
      });
  },

  GET_ORDER_HISTORY({ COMMIT }, params) {
    var vm = this;
    vm.commit("errors/CLEAR_ERRORS");

    axios
      .all([
        axios.get("/commerce-api/v1/orderHistory/overview", { params: params }),
      ])
      .then(
        axios.spread((response) => {
          vm.commit("orderHistory/SET_ORDER_HISTORY", response.data);
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit("errors/PUSH_ERROR", {
            message: error.response.data.title,
            code: error.response.status,
          });
        } else if (error.request) {
          vm.commit("errors/PUSH_ERROR", {
            message: "Couldn't contact the website",
          });
          console.log(error.request);
        } else {
          console.log("Error", error.message);
          vm.commit("errors/PUSH_ERROR", { message: error.message });
        }
        console.log(error.config);
      });
  },
  GET_ORDER_DETAILS({ COMMIT }, orderId) {
    var vm = this;
    vm.commit("errors/CLEAR_ERRORS");
    vm.commit("orderHistory/SET_FETCHING_ORDER_DETAILS", true);

    axios
      .all([axios.get("/commerce-api/v1/orderHistory/" + orderId + "/details")])
      .then(
        axios.spread((response) => {
          vm.commit("orderHistory/SET_ORDER_DETAILS", response.data);
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit("errors/PUSH_ERROR", {
            message: error.response.data.title,
            code: error.response.status,
          });
        } else if (error.request) {
          vm.commit("errors/PUSH_ERROR", {
            message: "Couldn't contact the website",
          });
          console.log(error.request);
        } else {
          console.log("Error", error.message);
          vm.commit("errors/PUSH_ERROR", { message: error.message });
        }
        console.log(error.config);
      })
      .finally(() => {
        vm.commit("orderHistory/SET_FETCHING_ORDER_DETAILS", false);
      });
  },
  ADD_ITEMS_TO_CART({ COMMIT }, items) {
    var vm = this;

    /**
     * Adds items to the cart. The `items` array should look like this
     * "items": [{
        "allowSubstitution": true,
        "productId": "string",
        "quantity": 0,
        "skuId": "string",
        "note": "string",
        "weight": 0
      }]
    */

    /**
     * I would like to keep this for testing purposes
     * items = {
        'items': [
          {
            'productId': '1546369',
            'skuId': '4122090325',
            'quantity': 2,
            'note': 'Green sauce for the win',
            'allowSubstitution': true
          },
          {
            'productId': 'FAKE_PRODUCT',
            'skuId': 'FAKE_SKU',
            'quantity': 2,
            'note': 'There is no Dana only Zuul'
          },
          {
            'productId': '1533675',
            'skuId': '85518800301',
            'quantity': 4,
            'note': 'Peanut butter makes my mouth happy'
          }
        ]
      }

      let error = {
        'errors': [
          {
            'product': {
              'thumbnailImageUrl': 'https://s7d5.scene7.com/is/image/HEBGrocery/prd-thumbnail/h-e-b-that-green-sauce-medium-001546369.jpg',
              'pricedByWeight': false,
              'defaultLevelOneCategory': {
                'name': 'Food and Drinks',
                'id': '2865'
              },
              'displayName': 'H-E-B That Green Sauce Medium',
              'randomWeight': false,
              'pdpUrl': '/product-detail/h-e-b-that-green-sauce-medium/1546369',
              'id': '1546369',
              'defaultSku': {
                'thumbnailImageUrl': 'https://s7d5.scene7.com/is/image/HEBGrocery/prd-thumbnail/h-e-b-that-green-sauce-medium-001546369.jpg',
                'displayName': 'That Green Sauce Medium',
                'sceneSevenImage': '001546369',
                'customerFriendlySize': '11 OZ',
                'id': '4122090325'
              }
            },
            'code': 'error.invalidSku',
            'message': 'Invalid SKU'
          },
          {
            'code': 'error.invalidProduct',
            'message': 'Invalid Product'
          }
        ]
      }
      console.log('in the request', items)
    */

    axios
      .all([axios.post("/commerce-api/v1/cart/items", { items })])
      .then(
        axios.spread((response) => {
          if (response.status === 207) {
            vm.commit("orderHistory/SET_UNAVAILABLE_ITEMS", response.data);
          }
          VueStore.$store.dispatch("cart/LOAD_CART");
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit("errors/PUSH_ERROR", {
            message: error.response.data.title,
            code: error.response.status,
          });
        } else if (error.request) {
          vm.commit("errors/PUSH_ERROR", {
            message: "Couldn't contact the website",
          });
          console.log(error.request);
        } else {
          console.log("Error", error.message);
          vm.commit("errors/PUSH_ERROR", { message: error.message });
        }
        console.log(error.config);
      });
  },

  DELETE_ORDERED_ITEM({ COMMIT }, item) {
    var vm = this;
    axios
      .all([
        axios.delete(
          `/commerce-api/v1/orderHistory/${item.orderId}/${item.sequenceNumber}`
        ),
      ])
      .then(
        axios.spread((response) => {
          if (response.status === 200) {
            vm.commit("orderHistory/SET_ORDER_DETAILS", response.data);
          }
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit("errors/PUSH_ERROR", {
            message: error.response.data.title,
            code: error.response.status,
          });
        } else if (error.request) {
          vm.commit("errors/PUSH_ERROR", {
            message: "Couldn't contact the website",
          });
        } else {
          vm.commit("errors/PUSH_ERROR", { message: error.message });
        }
      });
  },

  // TODO: when API service is ready make sure that this matches and everything is correct
  DELETE_ORDER({ COMMIT }, orderId) {
    var vm = this;
    axios
      .all([axios.delete("/commerce-api/v1/orderHistory/" + orderId)])
      .then(
        axios.spread((response) => {
          if (response.status === 200) {
            window.location = "/my-account/your-orders";
          }
        })
      )
      .catch((error) => {
        // Error
        if (error.response) {
          vm.commit("errors/PUSH_ERROR", {
            message: error.response.data.title,
            code: error.response.status,
          });
        } else if (error.request) {
          vm.commit("errors/PUSH_ERROR", {
            message: "Couldn't contact the website",
          });
          console.log(error.request);
        } else {
          console.log("Error", error.message);
          vm.commit("errors/PUSH_ERROR", { message: error.message });
        }
      });
  },

  PUT_ITEM_NOTE({ COMMIT }, { orderId, sequenceNumber, note }) {
    var vm = this;
    vm.commit("errors/CLEAR_ERRORS");

    return axios
      .all([
        axios.put(
          `/commerce-api/v1/orderHistory/${orderId}/${sequenceNumber}/note`,
          {
            note: note.substring(0, 255),
          }
        ),
      ])
      .then(
        axios.spread((response) => {
          vm.commit("orderHistory/SET_ORDER_DETAILS", response.data);
          return response;
        })
      )
      .catch((error) => {
        if (error.response) {
          vm.commit("errors/PUSH_ERROR", {
            message: error.response.data.title,
            code: error.response.status,
          });
        } else if (error.request) {
          vm.commit("errors/PUSH_ERROR", {
            message: "Couldn't contact the website",
          });
        } else {
          vm.commit("errors/PUSH_ERROR", { message: error.message });
        }
        return error.response;
      });
  },
};

const mutations = {
  SET_ORDER_HISTORY(state, data) {
    this._vm.$set(this.state.orderHistory, "allHistory", data);
    // this.state.orderHistory.allHistory = data
  },
  SET_PAST_PURCHASES(state, data) {
    this._vm.$set(this.state.orderHistory, "pastPurchases", data);
  },
  SET_ORDER_DETAILS(state, data) {
    // organize the orderItems data so that items are grouped by their parent category
    let { orderItems, payments, priceDetails } = data.orderDetail;

    // create a lookup object for each category ID so we can quickly add an item to it
    let categoryObjById = {};
    let orderedCategoryIds = [];

    window.heb.data.general.l1.forEach((category) => {
      // need to make sure the category object is never modified here
      // so that we don't modify the window object; instead spread out
      // the category values into a new object
      categoryObjById[category.id] = {
        ...category,
        items: [],
      };
      orderedCategoryIds.push(category.id);
    });

    // go through each order item returned from the API and add it to its category list
    orderItems.forEach((item) => {
      const itemCategoryName = get(
        item.product,
        "defaultLevelOneCategory.name",
        "Uncategorized"
      );
      const itemCategoryId = get(
        item.product,
        "defaultLevelOneCategory.id",
        itemCategoryName
      );

      if (categoryObjById[itemCategoryId]) {
        categoryObjById[itemCategoryId].items.push(item);
      } else {
        // this isn't one of the L1 categories; add the new category with some extra props
        categoryObjById[itemCategoryId] = {
          id: itemCategoryId,
          shortDisplayName: itemCategoryName,
          displayName: itemCategoryName,
          items: [item],
        };
        orderedCategoryIds.push(itemCategoryId);
      }
    });

    // we no longer need the lookup object, so convert it to an array
    // in proper L1 order. each array item will have the category ID, name, and its
    // list of order items
    let sortedItems = orderedCategoryIds.reduce(
      (acc, id) => {
        if (categoryObjById[id].items.length > 0) {
          // only include categories that have items
          acc.push(categoryObjById[id]);
        }
        return acc;
      },
      []
    );

    const usingEbt = some(payments, (payment) => payment.method === "EBT_SNAP");
    if (usingEbt) {
      // If they've selected an EBT card, sort the cart items by SNAP eligible/ineligible.
      // This is done after the normal category sort so that it retains the normal
      // category order within the new parent categories.
      const snapItems = [];
      const nonSnapItems = [];
      const ebtSubtotal = get(priceDetails, "ebtSnapSubtotal.formattedAmount", "");
      const nonEbtSubtotal = get(priceDetails, "nonEbtSnapItemSubtotal.formattedAmount", "");

      sortedItems.forEach(category =>
        category.items.forEach(item => item.snapEligible ? snapItems.push(item) : nonSnapItems.push(item))
      );

      sortedItems = [];
      if (snapItems.length) {
        sortedItems.push({
          id: 'snapEligible',
          shortDisplayName: `SNAP eligible${ebtSubtotal && `: ${ebtSubtotal}`}`,
          displayName: `SNAP eligible${ebtSubtotal && `: ${ebtSubtotal}`}`,
          items: snapItems,
        });
      }
      if (nonSnapItems.length) {
        sortedItems.push({
          id: 'snapIneligible',
          shortDisplayName: `SNAP ineligible${nonEbtSubtotal && `: ${nonEbtSubtotal}`}`,
          displayName: `SNAP ineligible${nonEbtSubtotal && `: ${nonEbtSubtotal}`}`,
          items: nonSnapItems,
        });
      }
    }
    data.orderDetail.orderItemsByCategoryId = sortedItems;

    this._vm.$set(this.state.orderHistory, "singleOrder", data.orderDetail);
  },
  SET_FETCHING_ORDER_DETAILS(state, isFetching) {
    this._vm.$set(this.state, "isFetchingOrderDetails", isFetching);
  },
  SET_UNAVAILABLE_ITEMS(state, data) {
    if (data) {
      this._vm.$set(
        this.state.orderHistory,
        "unavailableListOfItems",
        data.errors
      );
    } else {
      // Reset list
      this._vm.$set(this.state.orderHistory, "unavailableListOfItems", []);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
